import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Include Both Helper File with needed methods
import {
	getFoldersList as getFoldersApi,
	getFolder as getFolderApi,
	getFolderStructure as getFolderStructureApi,
	addNewFolder as addNewFolderApi,
	updateFolder as updateFolderApi,
	updateFileFavourites as updateFileFavouritesApi,
	deleteFolder as deleteFolderApi,
	getFilesList as getFilesApi,
	getFile as getFileApi,
	uploadFiles as uploadFilesApi,
	uploadFile as uploadFileApi,
	uploadFileImage as uploadFileImageApi,
	uploadFoldersFile as uploadFoldersFileApi,
	updateFile as updateFileApi,
	deleteFile as deleteFileApi,
	downloadFile as downloadFileApi,
	getFileType as getFileTypeApi,
	getFileTypeByCode as getFileTypeByCodeApi,
	getImageBase64
} from '../../helpers/file_manager/backend_helper';

export const getFolders = createAsyncThunk('fileManager/getFolders', async query => {
	try {
		const response = await getFoldersApi(query);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getFolder = createAsyncThunk('fileManager/getFolder', async query => {
	try {
		const response = await getFolderApi(query);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getFolderStructure = createAsyncThunk('fileManager/getFolderStructure', async (params) => {
	try {
		const response = await getFolderStructureApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewFolder = createAsyncThunk('fileManager/addNewFolder', async folder => {
	try {
		const response = await addNewFolderApi(folder);
		toast.success('Carpeta añadida con éxito', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al añadir la carpeta', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateFolder = createAsyncThunk('fileManager/updateFolder', async data => {
	try {
		const response = await updateFolderApi(data);
		toast.success('Carpeta actualizada con éxito', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar la carpeta', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const deleteFolder = createAsyncThunk('fileManager/deleteFolder', async folder => {
	try {
		const response = await deleteFolderApi(folder);
		toast.success('Carpeta eliminada con éxito', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al eliminar la carpeta', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const getFiles = createAsyncThunk('fileManager/getFiles', async query => {
	try {
		const response = await getFilesApi(query);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getFileType = createAsyncThunk('fileManager/getFileType', async code => {
	try {
		const response = await getFileTypeApi(code);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});


export const getFileTypeByCode = createAsyncThunk('fileManager/getFileTypeByCode', async code => {
	try {
		const response = await getFileTypeByCodeApi(code);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getFile = createAsyncThunk('fileManager/getFile', async query => {
	try {
		const response = await getFileApi(query);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const uploadFiles = createAsyncThunk('fileManager/uploadFiles', async data => {
	try {
		const response = await uploadFilesApi(data);
		return response;
	} catch (error) {
		toast.error('Error al subir el archivo', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const uploadFile = createAsyncThunk('fileManager/uploadFile', async data => {
	try {
		const response = await uploadFileApi(data);
		return response;
	} catch (error) {
		toast.error('Error al subir el archivo', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const uploadFileImage = createAsyncThunk('fileManager/uploadFileImage', async data => {
	try {
		const response = await uploadFileImageApi(data);
		return response;
	} catch (error) {
		toast.error('Error al subir el archivo', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const uploadFoldersFile = createAsyncThunk('fileManager/uploadFoldersFile', async data => {
	try {
		const response = await uploadFoldersFileApi(data);
		// toast.success('Archivo subido con éxito', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al subir el archivo', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const downloadFile = createAsyncThunk('fileManager/downloadFile', async data => {
	if (data?.disable_msg !== true) {
			toast.info('Estamos preparando la descarga del archivo', { autoClose: 3000 });
	}
	try {
			const response = await downloadFileApi(data);
			if (data?.disable_msg !== true) {
					toast.success('Archivo descargado con éxito', { autoClose: 3000 });
			}
			return response;
	} catch (error) {
			toast.error('Error al descargar el archivo', { autoClose: 3000 });
			throw new Error(error);
	}
});


export const updateFile = createAsyncThunk('fileManager/updateFile', async file => {
	try {
		const response = await updateFileApi(file);
		toast.success('Archivo actualizado con éxito', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar el archivo', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateFoldersFile = createAsyncThunk('fileManager/updateFoldersFile', async file => {
	try {
		const response = await updateFoldersFileApi(file);
		toast.success('Archivo actualizado con éxito', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar el archivo', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateFileFavourites = createAsyncThunk('fileManager/updateFileFavourites', async data => {
	try {
		const response = await updateFileFavouritesApi(data);
		toast.success('Favoritos actualizados con éxito', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar favoritos', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const deleteFile = createAsyncThunk('fileManager/deleteFile', async file_id => {
	try {
		const response = await deleteFileApi(file_id);
		return response;
	} catch (error) {
		toast.error('Error al eliminar el archivo', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const downloadImageBase64 = createAsyncThunk('fileManager/downloadImageBase64', async (url) => {
	try {
		const response = await getImageBase64(url);
		return response;  // Devolver solo la cadena base64
	} catch (error) {
		toast.error('Error al obtener la imagen', { autoClose: 3000 });
		throw new Error(error);
	}
});


